"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
var axios_1 = __importDefault(require("axios"));
var nprogress_1 = __importDefault(require("nprogress"));
var Api = /** @class */ (function () {
    function Api() {
        var _this = this;
        this._loadCounter = 0;
        Api.instance = this;
        this._axiosInstance = axios_1.default.create();
        this._axiosInstance.interceptors.request.use(function (config) {
            if (_this._loadCounter === 0) {
                nprogress_1.default.start();
            }
            _this._loadCounter += 1;
            return config;
        });
        this._axiosInstance.interceptors.response.use(function (value) {
            _this._loadCounter -= 1;
            if (_this._loadCounter === 0) {
                /* Do not flicker! */
                setTimeout(function () {
                    /* Still at zero? */
                    if (_this._loadCounter === 0) {
                        nprogress_1.default.done();
                    }
                }, 300);
            }
            return value;
        }, function (error) {
            // const status = error.response ? error.response.status : null
            // console.log('@FIXME service/api.tsx -> spinner doesnt stop spinning. axios response is:', error);
            nprogress_1.default.done();
            return Promise.reject(error);
        });
    }
    Object.defineProperty(Api.prototype, "axiosInstance", {
        get: function () {
            return this._axiosInstance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Api, "instance", {
        get: function () {
            var _a;
            return (_a = this._instance) !== null && _a !== void 0 ? _a : new Api();
        },
        set: function (api) {
            this._instance = api;
        },
        enumerable: false,
        configurable: true
    });
    return Api;
}());
exports.Api = Api;
//# sourceMappingURL=api.js.map